import { Box } from '@mui/material'
import PropTypes from 'prop-types'

const classes = {
    root: {
        height: 32,
    },
}

const AppLogo = ({ logoUrl, onClick = null, sx }) => {
    return logoUrl ? (
        <Box
            alt="[Logo Image]"
            component="img"
            src={logoUrl}
            sx={[classes.root, ...(Array.isArray(sx) ? sx : [sx])]}
            onClick={onClick}
        />
    ) : null
}

AppLogo.propTypes = {
    logoUrl: PropTypes.string,
    sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])),
        PropTypes.func,
        PropTypes.object,
    ]),
    onClick: PropTypes.func,
}

export default AppLogo
